export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}form/question-pool/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/QuestionPool/index.js